/**
 * Product analytics instrumentation.
 *
 * Tracks user behavior events from the React frontend. Events are sent
 * to the backend's track_event() which writes to app.analytics_events
 * (PostgreSQL) and structlog (Loki). No external analytics service required.
 *
 * Usage:
 *   import { trackEvent, identifyUser } from '@/lib/analytics'
 *   trackEvent('training_started', { model_type: 'rf' })
 */

import { emitDevDiagnostic } from './devDiagnostics'

/**
 * Initialize analytics. Currently a no-op — events are fire-and-forget
 * via the backend. Kept for API compatibility.
 */
export function initAnalytics(): void {
  // No-op — backend handles storage via platform_sdk.analytics.track_event()
}

/**
 * Track a product analytics event.
 * Emits a development-only diagnostic event. Backend fires events via track_event().
 */
export function trackEvent(event: string, properties?: Record<string, unknown>): void {
  emitDevDiagnostic('debug', 'analytics_track_event', { event, properties })
}

/**
 * Identify the current user for analytics.
 * Backend identifies users via X-User-Id header on every request.
 */
export function identifyUser(userId: string, traits?: Record<string, unknown>): void {
  emitDevDiagnostic('debug', 'analytics_identify_user', { userId, traits })
}
